/**
 * @file: 卧柜列选择
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as SelectToolkit from '../toolkit';
import CodiSystem from '../../../codiSystem/index';
import Message from '../message';

function selectByTarget(targetCube: CubeId): void {
    if (!CubeTree.isGoods(targetCube) && !CubeTree.isTextarea(targetCube)) {
        return;
    }

    let selectedCubes: CubeId[] = findSelectCubes(targetCube);

    if (SelectToolkit.cubeListInSelect(selectedCubes)) {
        SelectToolkit.removeGroup(selectedCubes);
    }
    else {
        SelectToolkit.addGroup(selectedCubes);
    }

    Message.panelSelectAsync();
}


function findSelectCubes(targetCube: CubeId): CubeId[] {
    let sameLeftCubes: CubeId[] = CodiSystem.findSameLeftCube(targetCube);

    return sameLeftCubes
        .filter((sameLeftCube: CubeId): boolean => {
            return CubeTree.isGoods(sameLeftCube) || CubeTree.isTextarea(sameLeftCube);
        })
        .concat([targetCube])
        .filter((cube: CubeId): boolean => {
            return SelectToolkit.idCanSelect(cube);
        });
}

export {
    selectByTarget
};
